export default "__VITE_ASSET__D9SVLT8l__"